import type { ReactNode } from "react";

import { useHost } from "@/host/host";

/**
 * A link to another site. In the browser it opens in a new tab; under the
 * companion's shell (decision 064) the shell opens it in the pilot's
 * browser, since the window shows this application alone.
 */
export function External({ href, className = "underline", children }: { href: string; className?: string; children: ReactNode }) {
  const host = useHost();
  return (
    <a
      className={className}
      href={href}
      target="_blank"
      rel="noreferrer"
      onClick={(e) => {
        if (!host) return;
        e.preventDefault();
        void host.openUrl(href);
      }}
    >
      {children}
    </a>
  );
}
